// 微前端通信
import { initGlobalState } from 'qiankun'
import store from '../store/index.js'
import { openLink } from '@/utils/openTab.js'

const initialStateDescription = {
  数据结构描述信息: {
    vesrion: '数据结构的版本号',
    kind: '数据结构的标识，该数据标识是主窗体程序提供的基础信息，还是某个应用程序提供的运行时信息',
    hasAuth: '快速判断是否权限的方法。传入控制点标识，返回是否具备权限',
    openTab:
      '从子应用打开标签页，参数是obj: {pageUrl: 应用域名+路由地址，applicationName：应用唯一标识，pageTitle：tab展示名, type: toMicroApp}',
    getEnv: '获取当前组织等信息',
    getUser: '获取登陆的账户信息，包括账户id，人员信息',
    'env: 函数getEnv返回的内容': {
      'currentOrg：当前组织': {
        id: '当前组织id',
        orgCode: '当前组织标识',
        orgName: '当前组织名称',
      },
      'device:可调用设备的信息': {
        printers: '打印机列表',
      },
    },
    'app: 当前应用的信息': {
      appName: '当前应用的名称，该值可用于区别微应用的唯一性',
      microFrontFlag: '微应用标识，为1表示是微应用，为0非微应用',
      uiUrl: '前端UI地址',
      sevUrl: '调用的后端接口服务地址',
      'style:样式管理': {
        theme: '主题',
        cssfile: '样式文件',
      },
    },
    'user: 函数getUser返回的内容': {
      accountName: '账号名',
      accountId: '账号id',
      token: '接口携带的请求头Authorization的值',
      perId: '当前组织下人员id',
      perName: '当前组织下人员名称',
      perCode: '当前组织下人员编码',
    },
  },
}

const initialState = {
  ...initialStateDescription,
  // 数据结构的版本号
  vesrion: 'v1',
  // 数据结构的标识，该数据标识是主窗体程序提供的基础信息，还是应用程序提供的运行时信息
  kind: 'nipponia[main]',
  metadata: {
    // 可以放置一些关于该数据结构的描述
  },
  openTab: openLink,
  getEnv() {
    const env = {
      currentOrg: {
        id: store.state.currentOrg.id,
        orgName: store.state.currentOrg.orgName,
        orgCode: store.state.currentOrg.orgCode,
      },
      device: {
        printers: store.state.pcCommonData.printers || [],
      },
    }
    return env
  },
  getUser() {
    const user = {
      accountName: store.state.keycloakToken.tokenParsed.preferred_username,
      accountId: store.state.keycloakToken.tokenParsed.sub,
      token: store.state.keycloakToken.token,
      perId: store.state.currentPersonInfo.perId,
      perName: store.state.currentPersonInfo.perName,
      perCode: store.state.currentPersonInfo.perCode,
    }
    return user
  },
  // 快速判断是否权限的方法。传入控制点标识，返回是否具备权限。
  hasAuth: function (code = '') {
    const funcodes = store.state.currentAppAuthsInOrg
    return funcodes.includes(code)
  },
  // 当前应用的信息
  app: {
    // 当前应用的名称
    appName: 'sample',
    // 微应用标识
    microFrontFlag: '1',
    // UI地址
    uiUrl: 'http://sample.dev0.palt5.ant.magicsmithy.sitir.net',
    // 服务地址
    sevUrl: 'http://sample.dev0.palt5.ant.magicsmithy.sitir.net',
    // 样式管理（预留）
    style: {
      // 主题
      theme: '',
      // cssfile 或则其他可以用来传递样式的方式
      cssfile: '',
    },
  },
  // loadMicroApp: null, // 从微应用加载其他微应用页面
  // openTab: null, // 从微应用打开新标签页处理
  historyAction: null, // 历史记录行为：null/push/pop
}

export { initialState }

// 初始化 state
const actions = initGlobalState(initialState)
export default actions
